/*
 * Quick-add for the cart drawer recommendation block.
 * Uses event delegation so it keeps working after the drawer re-renders.
 */
(function () {
  var SELECTOR = '[data-cart-rec-add]';

  function routeRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function addToCart(button) {
    var variantId = button.dataset.variantId;
    if (!variantId) return;

    var drawer = document.querySelector('cart-drawer');
    var sections = [];

    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      sections = drawer.getSectionsToRender().map(function (section) {
        return section.id;
      });
    }

    button.classList.add('is-loading');
    button.setAttribute('aria-disabled', 'true');

    fetch(routeRoot() + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/javascript',
      },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1 }],
        sections: sections,
        sections_url: window.location.pathname,
      }),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        if (data.status) {
          console.warn('[cart-rec]', data.description || data.message);
          return;
        }

        if (drawer && typeof drawer.renderContents === 'function') {
          drawer.renderContents(data);
        } else {
          window.location = routeRoot() + 'cart';
        }

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-drawer-recommendations' });
        }
      })
      .catch(function (error) {
        console.error('[cart-rec]', error);
      })
      .finally(function () {
        button.classList.remove('is-loading');
        button.removeAttribute('aria-disabled');
      });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest(SELECTOR);
    if (!button) return;
    if (button.getAttribute('aria-disabled') === 'true') return;

    event.preventDefault();
    addToCart(button);
  });
})();
